export const PERSIST_STATE_CHANGE = 'PERSIST_STATE_CHANGE';


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence/src/actions/actionTypes.js